type Props = React.SVGAttributes<SVGElement> & {
  iconColor?: string
}

export const CheckIcon = ({ iconColor, ...props }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.114 3.53623C12.5455 3.10479 13.245 3.10479 13.6764 3.53623C14.1026 3.96238 14.1078 4.65006 13.6921 5.08262L7.81144 12.4334C7.80296 12.4441 7.79389 12.4542 7.78428 12.4638C7.35284 12.8952 6.65333 12.8952 6.22189 12.4638L2.32358 8.56548C1.89214 8.13404 1.89214 7.43454 2.32358 7.00309C2.75502 6.57165 3.45453 6.57165 3.88597 7.00309L6.9698 10.0869L12.0847 3.56928C12.0938 3.55768 12.1036 3.54665 12.114 3.53623Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
